import {
  Button,
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  ScrollArea,
} from '@e2n/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  getWiederholungStringFromTerminWiederholung,
  TerminWiederholung,
} from '@/domain/termine/shared/types/TerminWiederholung';
import { useDrawerSelection } from '@/domain/termine/features/UpdateTermin/Mobile/hooks/useDrawerSelection';
import { useState } from 'react';

interface RepetitionIntervalDrawerProps {
  value: TerminWiederholung;
  onChange: (value: TerminWiederholung) => void;
}

export function RepetitionIntervalDrawer({
  value,
  onChange,
}: RepetitionIntervalDrawerProps) {
  const { t } = useTranslation();
  const { localSelection, handleOpenChange, handleSelect } =
    useDrawerSelection<TerminWiederholung>(value, onChange);
  const [open, setOpen] = useState(false);

  return (
    <Drawer
      open={open}
      onOpenChange={(isOpen) => {
        setOpen(isOpen);
        handleOpenChange(isOpen);
      }}>
      <DrawerTrigger asChild>
        <Button variant="outline-secondary" className="w-full justify-between">
          <span className="text-sm">
            {getWiederholungStringFromTerminWiederholung(localSelection)}
          </span>
          <FontAwesomeIcon icon={faChevronDown} className="text-neutrals-400" />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="flex flex-col">
        <DrawerHeader className="shrink-0">
          <DrawerTitle className="text-sm text-center text-neutrals-900 font-semibold">
            {t('domain.termine.repeat')}
          </DrawerTitle>
          <DrawerDescription className="sr-only">
            {t('domain.termine.repeat')}
          </DrawerDescription>
        </DrawerHeader>
        <ScrollArea className="flex-1 p-4" data-vaul-no-drag>
          <div className="space-y-0">
            {Object.values(TerminWiederholung).map((enumValue, idx) => {
              const isSelected = localSelection === enumValue;
              return (
                <div key={enumValue}>
                  <Button
                    variant="ghost"
                    aria-selected={isSelected}
                    onClick={() => {
                      handleSelect(enumValue);
                      onChange(enumValue);
                      setOpen(false);
                    }}
                    className="w-full justify-between">
                    <span className="text-sm font-medium">
                      {getWiederholungStringFromTerminWiederholung(enumValue)}
                    </span>
                    {isSelected && (
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="text-primary-blue-600"
                      />
                    )}
                  </Button>
                  {idx < Object.values(TerminWiederholung).length - 1 && (
                    <div className="border-b border-neutrals-300" />
                  )}
                </div>
              );
            })}
          </div>
        </ScrollArea>
      </DrawerContent>
    </Drawer>
  );
}
